import React from 'react';

/** The subtasks mark of the Boards Redesign artboards (Main / Card anatomy):
 *  two ticked rows — drawn as on the artboard, which no lucide icon matches
 *  (ListChecks has a third, middle line). */
export default function SubtasksIcon({ size = 11, strokeWidth = 2.2, className }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <path d="m3 7 2 2 4-4M3 17l2 2 4-4M13 6h8M13 18h8" />
    </svg>
  );
}
